module.exports = __webpack_public_path__ + "static/media/harry_m.031539c3.jpg";